import React from "react";
import { useLotData } from "../../../../../../api/inventory/use-lot-data";
import { LotTable } from "./lot-table";

const LotModal = (props) => {
  const { setTriggerCloseLotModal, productData, prodId } = props;
  const { isEmpty, getDataTableProps } = useLotData({}, prodId);
  const totalQty = getDataTableProps().data?.reduce((a, b) => a + b.qnt, 0);

  const onCloseLotModal = () => {
    setTriggerCloseLotModal(true);
  };

  return (
    <div className="mx-auto">
      <div className="flex items-center justify-between pb-[8px] border-b border-b-primary-grey">
        <h1 className="text-[16px] px-5 font-bold">LOT 재고 정보</h1>
        <button
          onClick={onCloseLotModal}
          className="border mr-5 px-6 py-1 border-button-grey rounded-[4px]"
        >
          닫기
        </button>
      </div>
      <div className="px-5 py-4">
        <div>
          <div className="border py-2 px-4 text-white border-primary-blue bg-primary-blue">
            상품정보
          </div>
          <div className="flex w-full">
            <div className="flex w-[50%]">
              <h1
                className={`border py-2 w-28 flex-none px-4 border-r-0 border-disable-grey bg-input-grey`}
              >
                카테고리
              </h1>

              <div className="flex items-center border-disable-grey px-2 outline-none border-r-0 border w-full">
                {productData?.productGroup?.productGroupCategory?.name}
              </div>
            </div>
            <div className="flex w-[50%]">
              <h1 className="border py-2 w-28 flex-none px-4 border-r-0 border-disable-grey bg-input-grey">
                REF(상품코드)
              </h1>
              <div className="flex items-center border-disable-grey px-2 outline-none w-full border">
                {productData?.ref}
              </div>
            </div>
          </div>
          <div className="flex w-full">
            <h1 className="border border-t-0 py-2 w-28 flex-none px-4 border-r-0 border-disable-grey bg-input-grey">
              상품명
            </h1>
            <div className="flex items-center border-disable-grey border-t-0 px-2 outline-none w-full border">
              {productData?.name}
            </div>
          </div>
        </div>
      </div>
      <div className="px-5 pb-4">
        <div className="border py-2 px-4 text-white border-primary-blue bg-primary-blue">
          재고정보 (현재 재고수량 : {totalQty}개)
        </div>
        <div>
          <LotTable
            prodId={prodId}
            isEmpty={isEmpty}
            getDataTableProps={getDataTableProps}
          />
        </div>
      </div>
    </div>
  );
};

export default LotModal;
